import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.css'
import { registerQuillExtendedFontSize } from '@/utils/quillFontSize'
import '@/utils/quillFontSize.css'
import { registerQuillFirstLineIndent } from '@/utils/quillFirstLineIndent'

registerQuillExtendedFontSize()
registerQuillFirstLineIndent()

Vue.config.productionTip = false

Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
